import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import FormTwo from '../component/contact/FormTwo';
import SectionTitle from '../elements/section-title/SectionTitle';
import ContactLocation from '../component/contact/ContactLocation';
import seoData from "../seoData/Contactdigi.json"
import Tilty from "react-tilty";

const Contactdigi = () => {
    return (
        <>
            <SEO {...seoData} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne
                    title="Contact Our Digital Marketing Team"
                    page="Digital Marketing"
                />

                <div className="section section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 mb--40">
                                <p style={{ maxWidth: "760px" }}>
                                    Looking for help with SEO, social media, paid campaigns, or branding? This
                                    is the fastest way to reach our digital marketing team directly, rather
                                    than our general project-inquiry desk. Tell us about your goals below and
                                    a strategist will follow up with next steps, not a generic sales pitch.
                                </p>
                            </div>
                            <div className="col-xl-5 col-lg-6">
                                <div className="contact-form-box shadow-box mb--30">
                                    <h2 className="title">Get In Touch</h2>
                                    <p>Fill up the form and our Team will get back to you within 24 hours.</p>
                                    <FormTwo />
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 offset-xl-1">
                                <Tilty
                                    perspective={12000}
                                    tiltMaxAngleX={0}
                                    tiltMaxAngleY={0}
                                    glare={false}
                                    scale={1.0}
                                    transitionSpeed={1000}
                                    reset={true}
                                >
                                    <div className="contact-info mb--100 mb_md--30 mt_md--0 mt--150">
                                        <h3 className="title">Phone</h3>
                                        <p>Our customer care is open from Mon-Fri, 9:00 am to 6:30 pm</p>
                                        <h4 className="phone-number"><a href="tel:+91 79904 01982">+91 79904 01982</a></h4>
                                    </div>
                                </Tilty>
                                <Tilty
                                    perspective={12000}
                                    tiltMaxAngleX={0}
                                    tiltMaxAngleY={0}
                                    glare={false}
                                    scale={1.0}
                                    transitionSpeed={1000}
                                    reset={true}
                                >
                                <div className="contact-info mb--30">
                                    <h3 className="title">Email</h3>
                                    <p>Our support team will get back to you within 24 hours during standard business hours.</p>
                                    <h4 className="phone-number"><a href="mailto:digital@itcodeinfotech.com">digital@itcodeinfotech.com</a></h4>
                                </div>
                                </Tilty>
                            </div>
                        </div>
                    </div>
                    <ul className="list-unstyled shape-group-12">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"} alt="Bubble" /></li>
                        <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Bubble" /></li>
                        <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.png"} alt="Circle" /></li>
                    </ul>
                </div>

                <div className="section section-padding bg-color-dark overflow-hidden">
                    <div className="container">
                        <SectionTitle
                            subtitle="Find Us :"
                            title="Our offices"
                            description="Give us a call or message. We will get back to you within 24 hours. Or you can even visit us."
                            textAlignment="heading-light-left"
                            textColor=""
                        />
                        <div className="row">
                            <ContactLocation />
                        </div>
                    </div>
                    <ul className="shape-group-11 list-unstyled">
                        <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/line-6.png"} alt="line" /></li>
                        <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/circle-3.png"} alt="line" /></li>
                    </ul>
                </div>

                <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
            </main>
        </>
    )
}

export default Contactdigi;